const findPathFromEntityId = require("./findPathFromEntityId");

module.exports = function extractLinkData(
	field_data,
	sitemap,
	default_label = "Learn more"
) {
	let to = field_data?.to ? field_data.to : field_data?.uri ? field_data.uri : null;
	if (to) {
		if (to.includes("internal:")) {
			to = to.replace("internal:", "");
		} else if (to.includes("entity:") && sitemap) {
			let nid = to.includes("node/") ? to.split("node/")[1] : null;
			if (nid) {
				let _to = findPathFromEntityId(nid, sitemap);
				if (_to) {
					to = _to;
				}
			}
		}
		const label =
			field_data?.title &&
			typeof field_data.title === "string" &&
			field_data.title.length > 0
				? field_data.title
				: default_label;

		return {
			label,
			to,
		};
	} else {
		return null;
	}
};
